import { render } from "./BadgeRound.vue?vue&type=template&id=4bc253ea"
import script from "./BadgeRound.vue?vue&type=script&lang=js"
export * from "./BadgeRound.vue?vue&type=script&lang=js"

import exportComponent from "/builds/descript/vue-js-teq-application/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__